import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Cigna Marketplace",
  shortName: "Cigna Marketplace",
  slug: "cigna-marketplace-insurance",
  seoTitle: "Cigna Marketplace TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have a Cigna Marketplace plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your ACA marketplace plan in Coral Springs, FL.",
  seoKeywords:
    "Cigna Marketplace TMS coverage, Cigna Marketplace TMS therapy, Cigna ACA depression treatment Florida, Cigna Marketplace mental health benefits, Cigna Marketplace SAINT TMS",
  planType: "Health Insurance Marketplace plan (ACA / Healthcare.gov)",
  planRegion: "Florida and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits as an essential health benefit, including mental health services",
  planSpecificIntro:
    "Cigna offers individual and family health insurance plans through the Health Insurance Marketplace (Healthcare.gov). These ACA-compliant plans include behavioral health benefits as one of the ten essential health benefits, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Cigna Marketplace plans come in different metal tiers — Bronze, Silver, Gold, and Platinum — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan tier, deductible, and network.",
  officialResourceUrl: "https://www.cigna.com/individuals-families/shop-plans/",
  officialResourceLabel: "Cigna Marketplace plans",
};

export const CignaMarketplaceInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default CignaMarketplaceInsurance;
